import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { IMPORT_FROM } from 'utils/GlobalVariables';
import { getMappingFiles } from 'services/API/Cooperative';
import ImportButtonListAndModal from './ImportButtonListAndModal';

const ImportData = ({ cooperativeId, mappingTypes, setMappingTypes }) => {
  const locationRoute = window.location.pathname.split('/')[1];
  const { t } = useTranslation();

  useEffect(() => {
    if (cooperativeId !== '') {
      getMappingFiles(cooperativeId)
        .then((resp) => {
          setMappingTypes(resp?.data?.data);
        })
        .catch((err) => {
          toast.error(t('errors.ERR_GET_MAPPING_FILES'));
        });
    }
  }, [cooperativeId]);

  return (
    <div className="section">
      <div className="main_container full-height">
        <div
          style={{ display: 'flex', justifyContent: 'center', alignItem: 'center', height: '50%' }}
        >
          <div
            className="button_upload"
            style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', marginTop: 50 }}
          >
            {mappingTypes !== null && (
              <ImportButtonListAndModal
                locationRoute={locationRoute}
                from={IMPORT_FROM.classic}
                mappingFiles={mappingTypes}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImportData;
